<template>
  <div>
    <div class="Box-form">
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item
          :label="$t('pilotService.planTable.applicationDate') + '：'"
        >
          <el-date-picker
            v-model="listQuery.date"
            type="date"
            size="small"
            placeholder="选择日期"
            :clearable="false"
            value-format="yyyy-MM-dd"
            class="date_picker w-265"
            @change="dateChange"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="table menuBox hidden-xs-only">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        max-height="500"
        :header-cell-style="{
          background: '#f9f9f9',
          color: 'black',
        }"
      >
        <el-table-column
          :label="$t('pilotService.planTable.serialNumber')"
          type="index"
          width="70"
        />
        <el-table-column
          prop="date"
          :label="$t('pilotService.planTable.date')"
          width="140"
        />
        <el-table-column
          prop="time"
          :label="$t('pilotService.planTable.time')"
          width="130"
          :formatter="formatter"
        />
        <el-table-column
          prop="device_name"
          :label="$t('pilotService.planTable.equipment')"
          min-width="170"
        />
        <el-table-column
          prop="trainkind_name"
          :label="$t('pilotService.planTable.trainingNature')"
          width="130"
        />
        <el-table-column
          prop="instructor"
          :label="$t('pilotService.planTable.teacher')"
          width="140"
        />
        <el-table-column
          prop="students"
          :label="$t('pilotService.planTable.student')"
          width="140"
        />
        <el-table-column
          v-if="name === 'first'"
          prop="device_pos"
          :label="$t('pilotService.planTable.position')"
          width="130"
        />
      </el-table>
    </div>

    <div class="hidden-sm-and-up">
      <el-card
        v-for="item in tableData"
        :body-style="{ padding: '15px' }"
        class="card"
      >
        <div class="card-list">
          <div class="top">
            <div class="card-content">
              {{ $t("pilotService.planTable.date") }}:{{ item.date }}
            </div>
            <div class="card-content">
              {{ $t("pilotService.planTable.time") }}:{{ item.time }}
            </div>
          </div>
          <div class="card-content">
            {{ $t("pilotService.planTable.equipment") }}：{{ item.device_name }}
          </div>
          <div class="card-content">
            {{ $t("pilotService.planTable.trainingNature") }}：{{
              item.trainkind_name
            }}
          </div>
          <div class="card-content">
            {{ $t("pilotService.planTable.teacher") }}：{{ item.instructor }}
          </div>
          <div class="card-content">
            {{ $t("pilotService.planTable.student") }}：{{ item.students }}
          </div>
          <div class="card-content">
            {{ $t("pilotService.planTable.position") }}：{{ item.device_pos }}
          </div>
        </div>
      </el-card>
    </div>
    <div class="pagination">
      <el-pagination
        @current-change="dateChange"
        :current-page.sync="listQuery.page"
        :page-size="listQuery.size"
        layout="total, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    loading: Boolean,
    listQuery: Object,
    totalNum: Number,
    tableData: Array,
  },
  data() {
    return {
      //   loading: false,
      //   listQuery: {
      //     page: 1,
      //     size: 10,
      //     date: `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
      //       .toString()
      //       .padStart(2, "0")}-${new Date()
      //       .getDate()
      //       .toString()
      //       .padStart(2, "0")}`,
      //   },
      //   totalNum: 0,
      //   tableData: [],
    };
  },
  methods: {
    formatter(row, column, cellValue, index) {
      //       if (column.property == "time") {
      //   return time;
      // }
    },
    dateChange() {
      this.$emit("dateChange");
    },
  },
};
</script>

<style scoped>
.pagination {
  padding: 20px;
  /* margin: 20px; */
  text-align: left;
}
.card {
  margin-bottom: 20px;
}
.card-list {
  display: flex;
  flex-wrap: wrap;
  font-size: 15px;
}
.top {
  width: 100%;
  display: flex;
  padding-bottom: 5px;
  border-bottom: 1px solid #dcdfe6;
  font-weight: 800;
}
.card-content {
  width: 50%;
  line-height: 40px;
}
</style>